function addNextPageToPagination() {
    const nextPage = $("[data-testid='linkNextPage']")

    if (nextPage.length) {
        const newNextPage = nextPage.clone()
        const lastPage = $(".pagination [data-testid='linkLastPage']")
        const nextPageNum = parseInt($('.current').text()) + 1

        if (lastPage.attr('href') === nextPage.attr('href')) {
            return
        }

        newNextPage.removeClass('next pagination-link')
        newNextPage.insertAfter('.pagination .current')
        newNextPage.text(nextPageNum)
    }
}

function categoryTop() {
    // přesunout obrázek mimo category-perex
    $('.category-perex p:has(img)').last().prependTo('.category-top').addClass('category-image')
    $('.category-title').prependTo('.category-perex')
}
function handleContentLoaded() {
    categoryTop()
    addNextPageToPagination()
}

function addPagination() {
    const paginationHtml = `
        <div class="pagination-top">
            <a class="pagination-link up js-scroll-top" href="#" data-testid="buttonPageUp"></a>
            <strong class="js-scroll-top">Nahoru</strong>
        </div>
        <div class="pagination-loader">
            <span class="load-products btn btn-default unveil-button" data-testid="buttonMoreItems">Zobrazit další</span>
        </div>
        <div class="pagination" data-testid="gridPagination">
            <a href="/pletova-kosmetika/" data-testid="linkFirstPage">1</a>
            <a class="prev pagination-link" href="/pletova-kosmetika/" data-testid="linkPreviousPage">
                <span class="sr-only">Předchozí stránka</span>
            </a>
            <strong class="current" data-testid="buttonCurrentPage">2</strong>
            <a href="/pletova-kosmetika/strana-3/" data-testid="linkNextPage">3</a>
            <a class="next pagination-link" href="/pletova-kosmetika/strana-3/" data-testid="linkNextPage">
                <span class="sr-only">Další strana</span>
            </a>
            <a href="/pletova-kosmetika/strana-7/" data-testid="linkLastPage">7</a>
        </div>`

    $('.pagination-wrapper').html(paginationHtml)
}

export function initCategory() {
    handleContentLoaded()

    document.addEventListener('ShoptetDOMPageContentLoaded', async function () {
        handleContentLoaded()
    })

    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', () => {
        addNextPageToPagination()
    })
}
